/*router.js*/
import { createRouter, createWebHashHistory } from 'vue-router';
import VueJwtDecode from 'vue-jwt-decode'
import Login from './pages/Login.vue'
import routePermissionsMap, { routeUserPermissionsMap } from './routePermissionsMap';
import { isPublicRoute } from './publicRoutes';
import axios from '@/utilities/Axios.js'
const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/unauthorized',
        name: 'unauthorized',
        component: () => import('./pages/Error.vue')
    },
    {
        path: '/',
        name: 'dashboard',
        exact: true,
        component: () => import('./components/homepage/index.vue'),
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Dashboard' }],
        },
    },
    // Dashboard Categorie (pagine intermedie navigabili)
    {
        path: '/categoria/condominio',
        name: 'categoria-condominio',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'condominio' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Condominio e Contatori', to: '/categoria/condominio' }],
        },
    },
    {
        path: '/categoria/gestione-aziendale',
        name: 'categoria-gestione-aziendale',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'gestione-aziendale' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Gestione Aziendale', to: '/categoria/gestione-aziendale' }],
        },
    },
    {
        path: '/categoria/cashflow',
        name: 'categoria-cashflow',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'cashflow' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Cash Flow', to: '/categoria/cashflow' }],
        },
    },
    {
        path: '/categoria/amministrazione',
        name: 'categoria-amministrazione',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'amministrazione' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Amministrazione', to: '/categoria/amministrazione' }],
        },
    },
    {
        path: '/categoria/anagrafiche',
        name: 'categoria-anagrafiche',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'anagrafiche' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Anagrafiche', to: '/categoria/anagrafiche' }],
        },
    },
    {
        path: '/categoria/commerciale',
        name: 'categoria-commerciale',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'commerciale' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Commerciale', to: '/categoria/commerciale' }],
        },
    },
    {
        path: '/categoria/risorse-umane',
        name: 'categoria-risorse-umane',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'risorse-umane' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Risorse Umane', to: '/categoria/risorse-umane' }],
        },
    },
    {
        path: '/categoria/corrieri',
        name: 'categoria-corrieri',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'corrieri' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Corrieri e Consegne', to: '/categoria/corrieri' }],
        },
    },
    {
        path: '/categoria/magazzini',
        name: 'categoria-magazzini',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'magazzini' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Magazzini', to: '/categoria/magazzini' }],
        },
    },
    {
        path: '/categoria/statistiche',
        name: 'categoria-statistiche',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'statistiche' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Statistiche e Report', to: '/categoria/statistiche' }],
        },
    },
    {
        path: '/categoria/incassi',
        name: 'categoria-incassi',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'incassi' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Incassi e Portafogli', to: '/categoria/incassi' }],
        },
    },
    {
        path: '/categoria/assistenza',
        name: 'categoria-assistenza',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'assistenza' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Assistenza e Riparazioni', to: '/categoria/assistenza' }],
        },
    },
    {
        path: '/categoria/ticket',
        name: 'categoria-ticket',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'ticket' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Ticket e Supporto', to: '/categoria/ticket' }],
        },
    },
    {
        path: '/categoria/utility',
        name: 'categoria-utility',
        component: () => import('./components/navigation/CategoryDashboard.vue'),
        props: { categoryKey: 'utility' },
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'Utility e Strumenti', to: '/categoria/utility' }],
        },
    },
    {
        path: '/demo',
        name: 'demo-dashboard',
        exact: true,
        component: () => import('.//components/TableDemo.vue'),
        meta: {
            breadcrumb: [{ parent: 'Demo', label: 'Dashboard Demo' }],
        },
    },
    {
        path: '/ticket/nuovo',
        name: 'nuovo-ticket',
        exact: true,
        component: () => import('.//components/ticket/new.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ticket', label: 'Nuovo Ticket' }],
        },
    },

    {
        path: '/ticketlist',
        name: 'ticketlist',
        exact: true,
        component: () => import('.//components/GestioneTicket/TicketList.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ticket', label: 'Lista Ticket' }],
        },
    },
    {
        path: '/agentedashboardticket',
        name: 'agentedashboardticket',
        exact: true,
        component: () => import('.//components/GestioneTicket/AgenteDashboard.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ticket', label: 'Dashboard Preventivi' }],
        },
    },
    {
        path: '/emaildetail',
        name: 'emaildetail',
        exact: true,
        component: () => import('.//components/GestioneTicket/EmailDetail.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ticket', label: 'Gestione Email' }],
        },
    },
    {
        path: '/ticketdetail/:id',
        name: 'ticketdetail',
        exact: true,
        component: () => import('.//components/GestioneTicket/TicketDetail.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ticket', label: 'Dettaglio' }],
        },
    },

    {
        path: '/ticketform',
        name: 'ticketform',
        exact: true,
        component: () => import('.//components/GestioneTicket/TicketForm.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ticket', label: 'Form Ticket' }],
        },
    },
    {
        path: '/inserimentomissioni',
        name: 'inserimentomissioni',
        exact: true,
        component: () => import('.//components/missioni/InserimentoMissioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Risorse Umane', label: 'Inserimento Missioni' }],
        },
    },
 /*   {
        path: '/checkmatricole',
        name: 'checkmatricole',
        exact: true,
        component: () => import('.//components/checkmatricole/CheckMatricole.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ticket', label: 'Nuovo' }],
        },
    },*/
    {
        path: '/richiestapermessieferie',
        name: 'richiestapermessieferie',
        exact: true,
        component: () => import('.//components/permessieferie/RichiestaPermessiEFerie.vue'),
        meta: {
            breadcrumb: [{ parent: 'Risorse Umane', label: 'Richiesta Permessi e Ferie' }],
        },
    },

    {
        path: '/approvezionepermessieferie',
        name: 'approvezionepermessieferie',
        exact: true,
        component: () => import('.//components/permessieferie/ApprovazionePermessiEFerie.vue'),
        meta: {
            breadcrumb: [{ parent: 'Risorse Umane', label: 'Approvazione Permessi' }],
        },
    },

    {
        path: '/parcoauto',
        name: 'parcoauto',
        exact: true,
        component: () => import('.//components/missioni/ParcoAuto.vue'),
        meta: {
            breadcrumb: [{ parent: 'Risorse Umane', label: 'Parco Auto' }],
        },
    },
    {
        path: '/chat',
        name: 'chat',
        exact: true,
        component: () => import('.//components/chat/Chat.vue'),
        meta: {
            breadcrumb: [{ parent: 'Chat', label: 'Messaggistica' }],
        },
        children: [
            {
                path: ':topicId',
                name: 'topic',
                component: () => import('.//components/chat/Topic.vue'),
            },
            {
                path: ':topicId/post/:postId',
                name: 'topicPost',
                component: () => import('.//components/chat/Topic.vue'),
            },
            {
                path: ':topicId/post/:postId/comment/:commentId',
                name: 'topicComment',
                component: () => import('.//components/chat/Topic.vue'),
            },
        ],
    },
    /*ho definito questa rotta per far si che gli utenti amministrativi entrino in questa dashboard. ho defitino questa regola in pages>loging.vue*/
    {
        path: '/amministrazione',
        name: 'amministrazione',
        exact: true,
        component: () => import('.//components/DashboardPerUtente/Amministrazione.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Amministrazione' }],
        },
    },

    {
        path: '/ufficioacquisti',
        name: 'ufficioacquisti',
        exact: true,
        component: () => import('.//components/DashboardPerUtente/UfficioAcquisti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Ufficio Acquisti' }],
        },
    },
    {
        path: '/scrivaniamagazzinomartina',
        name: 'scrivaniamagazzinomartina',
        exact: true,
        component: () => import('./components/DashboardPerUtente/ScrivaniaMagazzinoMartina.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Magazzino Martina Franca' }],
        },
    },
    {
        path: '/statistiche',
        name: 'statistiche',
        exact: true,
        component: () => import('./components/Statistiche.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Statistiche' }],
        },
    },

    {
        path: '/demo',
        name: 'demo',
        exact: true,
        component: () => import('./components/demo.vue'),
        meta: {
            breadcrumb: [{ parent: 'Demo', label: 'Dashboard Demo' }],
        },
    },
    {
        path: '/schedafornitore',
        name: 'schedafornitore',
        exact: true,
        component: () => import('./components/SchedaFornitore/SchedaFornitore.vue'),
        meta: {
            breadcrumb: [{ parent: 'Fornitori', label: 'Scheda Fornitore' }],
        },
    },

    {
        path: '/statistichedocumentiarca',
        name: 'statistichedocumentiarca',
        exact: true,
        component: () => import('./components/statistichedswebapp/ControlloPreventiviArca.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Documenti Arca' }],
        },
    },
    {
        path: '/invendutomagazzini',
        name: 'invendutomagazzini',
        exact: true,
        component: () => import('./components/magazzini/invendutoarticoli/invendutomagazzini.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Invenduto' }],
        },
    },

    {
        path: '/tasktoolpreventivi',
        name: 'tasktoolpreventivi',
        exact: true,
        component: () => import('./views/PreventiviView.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Lavori in corso' }],
        },
    },
    {
        path: '/gestionetrasferimenti',
        name: 'gestionetrasferimenti',
        exact: true,
        component: () => import('./components/magazzini/gestionetrasferimenti/GestioneTrasferimenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Trasferimenti' }],
        },
    },

    {
        path: '/gestionecarichimagazzino',
        name: 'gestionecarichimagazzino',
        exact: true,
        component: () => import('./components/magazzini/gestionecarichi/GestioneCarichi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Controllo Carichi' }],
        },
    },
    {
        path: '/gestioneinventario',
        name: 'gestioneinventario',
        exact: true,
        component: () => import('./components/magazzini/gestioneinventari/GestioneInventario.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Inventario' }],
        },
    },
    {
        path: '/cruscottomissioni',
        name: 'cruscottomissioni',
        exact: true,
        component: () => import('./components/magazzini/missionidimagazzino/CruscottoMissioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Cruscotto Missioni' }],
        },
    },
    {
        path: '/dettagliomissione/:id',
        name: 'dettagliomissione',
        exact: true,
        component: () => import('./components/magazzini/missionidimagazzino/DettaglioMissione.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Dettaglio Missione' }],
        },
    },
    {
        path: '/picking-ubicazioni',
        name: 'picking-ubicazioni',
        exact: true,
        component: () => import('./components/magazzini/PickingUbicazioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Picking Ubicazioni' }],
        },
    },
    {
        path: '/scorte-picking-per-ubicazione',
        name: 'scorte-picking-per-ubicazione',
        exact: true,
        component: () => import('./components/magazzini/ScortePickingPerUbicazione.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Scorte Picking per Ubicazione' }],
        },
    },
    {
        path: '/storico-movimenti-ubicazioni',
        name: 'storico-movimenti-ubicazioni',
        exact: true,
        component: () => import('./components/magazzini/StoricoMovimentiUbicazioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Storico Movimenti Ubicazioni' }],
        },
    },

    {
        path: '/verificaanomalie',
        name: 'verificaanomalie',
        exact: true,
        component: () => import('./components/magazzini/gestioneanomalie/VerificaAnomalie.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Verifica Anomalie' }],
        },
    },
    {
        path: '/tagliobarre',
        name: 'tagliobarre  ',
        exact: true,
        component: () => import('./components/DSLab/TaglioBarre.vue'),
        meta: {
            breadcrumb: [{ parent: 'Utility', label: 'Taglio Barre' }],
        },
    },
   
    // VERSIONE NUOVA (semplificata) - Usa questa!
    {
        path: '/gestione-contatori',
        name: 'gestione-contatori',
        exact: true,
        component: () => import('@/views/GestioneContatoriMain.vue'),
        meta: {
            breadcrumb: [{ parent: 'Condominio e Contatori', parentTo: '/categoria/condominio', label: 'Gestione Contatori' }],
        },
    },
    {
        path: '/articolipreferititagliobarre',
        name: 'articolipreferititagliobarre',
        exact: true,
        component: () => import('./components/DSLab/ArticoliPreferiti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Utility', label: 'Articoli Preferiti Taglio' }],
        },
    },
    {
        path: '/ordinievadibilimf',
        name: 'ordinievadibilimf',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/martinafranca/ordinievadibilimf.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Ordini Evadibili MF' }],
        },
    },

    {
        path: '/valorizzazionimagazzino',
        name: 'valorizzazionimagazzino',
        exact: true,
        component: () => import('./components/magazzini/valorizzazioni/ValorizzazioneMagazzino.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Valorizzazione' }],
        },
    },
    {
        path: '/giornaledimagazzino',
        name: 'giornaledimagazzino',
        exact: true,
        component: () => import('./components/magazzini/valorizzazioni/GiornaleDiMagazzino/GiornaleDiMagazzino.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Giornale di Magazzino' }],
        },
    },
    {
        path: '/indicedirotazioneglobale',
        name: 'indicedirotazioneglobale',
        exact: true,
        component: () => import('./components/magazzini/valorizzazioni/GiornaleDiMagazzino/IndiceDiRotazioneGlobale.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Indice Rotazione' }],
        },
    },
    {
        path: '/ordinievadibilimfGestore',
        name: 'ordinievadibilimfGestore',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/martinafranca/ordinievadibiliMFGestore.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Ordini Evadibili Gestore' }],
        },
    },

    {
        path: '/gestione-alert-clienti',
        name: 'gestione-alert-clienti',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/AlertClienti/GestioneAlertClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Anagrafiche', label: 'Alert Clienti' }],
        },
    },
    {
        path: '/listeapertemartina',
        name: 'listeapertemartina',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/martinafranca/listeapertemartina.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Liste Aperte Martina' }],
        },
    },
    {
        path: '/listeapertefuorifido',
        name: 'listeapertefuorifido',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/martinafranca/ListeAperteFuoriFido.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Liste Fuori Fido' }],
        },
    },
    {
        path: '/listeapertefotovoltaico',
        name: 'listeapertefotovoltaico',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/martinafranca/listeapertefotovoltaico.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Liste Fotovoltaico' }],
        },
    },
    {
        path: '/listeapertecasarano',
        name: 'listeapertecasarano',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/casarano/listeapertecasarano.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Liste Aperte Casarano' }],
        },
    },
    {
        path: '/listeaperteoria',
        name: 'listeaperteoria',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/oria/listeaperteoria.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Liste Aperte Oria' }],
        },
    },
    {
        path: '/listeapertemodugno',
        name: 'listeapertemodugno',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/modugno/listeapertemodugno.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Liste Aperte Modugno' }],
        },
    },

    {
        path: '/listeapertelecce',
        name: 'listeapertelecce',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/lecce/listeapertelecce.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Liste Aperte Lecce' }],
        },
    },
    {
        path: '/consegne',
        name: 'consegne',
        exact: true,
        component: () => import('./components/magazzini/corrieri/consegne.vue'),
        meta: {
            breadcrumb: [{ parent: 'Corrieri', label: 'Consegne' }],
        },
    },
    {
        path: '/consegnealbancomartinafranca',
        name: 'consegnealbancomartinafranca',
        exact: true,
        component: () => import('./components/magazzini/banconisti/ConsegneAlBancoMF.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Valorizzazione Banco MF' }],
        },
    },


    {
        path: '/corrieri',
        name: 'corrieri',
        exact: true,
        component: () => import('./components/magazzini/corrieri/corrieri.vue'),
        meta: {
            breadcrumb: [{ parent: 'Corrieri', label: 'Gestione Corrieri' }],
        },
    },
    {
        path: '/lavoratodelgiornomf',
        name: 'lavoratodelgiornomf',
        exact: true,
        component: () => import('./components/magazzini/dashboardmagazzini/martinafranca/lavoratodelgiornoMF.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Lavorato del Giorno MF' }],
        },
    },
    {
        path: '/confrontofatturati',
        name: 'confrontofatturati',
        exact: true,
        component: () => import('./components/DashboardPerUtente/ConfrontoFatturati.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Confronto Fatturati' }],
        },
    },

    /*{
        path: '/vendutodelmese',
        name: 'vendutodelmese',
        exact: true,
        component: () => import('./components/VenditeDelMese.vue'),
        meta: {
            breadcrumb: [{ parent: 'statistiche', label: 'Statistiche' }],
        },
    },*/
    {
        path: '/direzione',
        name: 'direzione',
        exact: true,
        component: () => import('.//components/DashboardPerUtente/Direzione.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Direzione' }],
        },
    },
    {
        path: '/giulioromanelli',
        name: 'giulioromanelli',
        exact: true,
        component: () => import('.//components/DashboardPerUtente/GiulioRomanelli.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Giulio Romanelli' }],
        },

    },

    {
        path: '/risorseaziendali',
        name: 'risorseaziendali',
        exact: true,
        component: () => import('.//components/RisorseAziendali/RisorseAziendali.vue'),
        meta: {
            breadcrumb: [{ parent: 'Gestione', label: 'Risorse Aziendali' }],
        },

    },
    {
        path: '/scrivaniadirezionale',
        name: 'scrivaniadirezionale',
        exact: true,
        component: () => import('.//components/DashboardPerUtente/ScrivaniaDirezionale.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Scrivania Direzionale' }],
        },

    },
    {
        path: '/fabrizioazzinnari',
        name: 'fabrizioazzinnari',
        exact: true,
        component: () => import('.//components/DashboardPerUtente/FabrizioAzzinnari.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Fabrizio Azzinnari' }],
        },

    },
    {
        path: '/pasqualezizzi',
        name: 'pasqualezizzi',
        exact: true,
        component: () => import('.//components/DashboardPerUtente/PasqualeZizzi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Pasquale Zizzi' }],
        },

    },
    {
        path: '/provvigioniscannicchio',
        name: 'provvigioniscannicchio',
        exact: true,
        component: () => import('./components/DashboardPerUtente/ProvvigioniScannicchio.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Provvigioni Scannicchio' }],
        },
    },
    {
        path: '/dashboardvendutodelgiorno',
        name: 'dashboarddirezo',
        exact: true,
        component: () => import('./components/DashboardPerUtente/DashboardVendutoDelGiorno.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Venduto del Giorno' }],
        },
    },
    {
        path: '/dashboardvendutodelgiornosemplice',
        name: 'dashboardvendutodelgiornosemplice',
        exact: true,
        component: () => import('./components/DashboardPerUtente/DashboardVendutoDelGiornoSemplificato.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Venduto Giorno Semplice' }],
        },
    },
    {
        path: '/dashboardvenduto4anni',
        name: 'dashboardvenduto4anni',
        exact: true,
        component: () => import('./components/DashboardPerUtente/DashboardVenduto4Anni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Venduto 4 Anni' }],
        },
    },
    
     {
        path: '/checkmatricoleufficiotecnico',
        name: 'checkmatricoleufficiotecnico',
        exact: true,
        component: () => import('./components/UfficioTecnico/CheckMatricole.vue'),
        meta: {
            breadcrumb: [{ parent: 'Risorse Umane', label: 'Check Matricole' }],
        },
    },
    {
        path: '/dashboardufficiotecnico',
        name: 'dashboardufficiotecnico',
        exact: true,
        component: () => import('./components/UfficioTecnico/DashboardUfficioTecnico.vue'),
        meta: {
            breadcrumb: [{ parent: 'Ufficio Tecnico', label: 'Dashboard' }],
        },
    },
    
    {
        path: '/dashboardletterepremioclienti',
        name: 'dashboardletterepremioclienti',
        exact: true,
        component: () => import('./components/LetterePremio/DashboardPremio.vue'),
        meta: {
            breadcrumb: [{ parent: 'Commerciale', label: 'Lettere Premio' }],
        },
    },
      {
        path: '/crealetterepremioclienti',
        name: 'crealetterepremioclienti',
        exact: true,
        component: () => import('./components/LetterePremio/CreaLetterePremioClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Commerciale', label: 'Crea Lettere Premio' }],
        },
    },
    {
        path: '/manutenzionesconticlienti',
        name: 'manutenzionesconticlienti',
        exact: true,
        component: () => import('./components/ManutenzioneScontiClienti/Index.vue'),
        meta: {
            breadcrumb: [{ parent: 'Commerciale', label: 'Manutenzione Sconti' }],
        },
    },
    {
        path: '/dashboardvenduto4anniold',
        name: 'dashboardvenduto4anniold',
        exact: true,
        component: () => import('./components/DashboardPerUtente/DashboardVenduto4AnniOld.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Venduto 4 Anni Old' }],
        },
    },

    {
        path: '/checkarticolineipreventivi',
        name: 'checkarticolineipreventivi',
        exact: true,
        component: () => import('./components/DashboardPerUtente/CheckArticoliNeiPreventivi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Commerciale', label: 'Check Articoli Preventivi' }],
        },
    },
    {
        path: '/dashboardvenduto4anniclienti',
        name: 'dashboardvenduto4anniclienti',
        exact: true,
        component: () => import('./components/DashboardPerUtente/DashboardVenduto4AnniClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Venduto 4 Anni Clienti' }],
        },
    },
    {
        path: '/dashboardvenduto4anniclientigiornaliero',
        name: 'dashboardvenduto4anniclientigiornaliero',
        exact: true,
        component: () => import('./components/DashboardPerUtente/DashboardVenduto4AnniClientiGiornaliero.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Venduto 4 Anni Clienti' }],
        },
    },
    /*COMPONENT FORNITORI*/

    {
        path: '/acquisti',
        name: 'acquisti',
        exact: true,
        component: () => import('@/components/fornitori/Acquisti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Fornitori', label: 'Acquisti' }],
        },
    },
    {
        path: '/importpromo',
        name: 'importpromo',
        exact: true,
        component: () => import('.//components/ManutenzioneListini/ImportPromo.vue'),
        meta: {
            breadcrumb: [{ parent: 'Fornitori', label: 'Import Promo' }],
        },
    },
    {
        path: '/indexincassi',
        name: 'indexincassi',
        exact: true,
        component: () => import('.//components/moduloincassi/IndexIncassi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Wizard Incassi' }],
        },
    },
    {
        path: '/sospesiperagente',
        name: 'sospesiperagente',
        exact: true,
        component: () => import('.//components/amministrazione/sospesi/SospesiPerAgente.vue'),
        meta: {
            breadcrumb: [{ parent: 'Amministrazione', label: 'Sospesi per Agente' }],
        },
    },
    {
        path: '/listasinistriassicurativi',
        name: 'listasinistriassicurativi',
        exact: true,
        component: () => import('.//components/amministrazione/sospesi/ListaSinistriAssicurativi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Amministrazione', label: 'Sinistri Assicurativi' }],
        },
    },
    {
        path: '/gestioneassicuratori',
        name: 'gestioneassicuratori',
        exact: true,
        component: () => import('.//components/amministrazione/sospesi/GestioneAssicuratori.vue'),
        meta: {
            breadcrumb: [{ parent: 'Amministrazione', label: 'Gestione Assicuratori' }],
        },
    },

    {
        path: '/creascadenzaricorrente',
        name: 'creascadenzaricorrente',
        exact: true,
        component: () => import('.//components/amministrazione/pagamentiricorrenti/CreaScadenzaRicorrente.vue'),
        meta: {
            breadcrumb: [{ parent: 'Amministrazione', label: 'Crea Scadenza Ricorrente' }],
        },
    },
    {
        path: '/pagamentiricorrenti',
        name: 'pagamentiricorrenti',
        exact: true,
        component: () => import('.//components/amministrazione/pagamentiricorrenti/PagamentiRicorrenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Amministrazione', label: 'Pagamenti Ricorrenti' }],
        },
    },
    {
        path: '/matchscadenzeexcel',
        name: 'matchscadenzeexcel',
        exact: true,
        component: () => import('.//components/amministrazione/scadenze/MatchScadenzeExcel.vue'),
        meta: {
            breadcrumb: [{ parent: 'Amministrazione', label: 'Match Scadenze Excel' }],
        },
    },
    {
        path: '/incassi/:Cd_CF',
        name: 'incassi',
        exact: true,
        //component: () => import('.//components/moduloincassi/DaCrm/Step2.vue'),
        component: () => import('.//components/moduloincassi/Step2.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Incassi Cliente' }],
        },
    },
    {
        path: '/articoli/:Cd_AR*',
        name: 'articoli',
        exact: true,
        //component: () => import('.//components/moduloincassi/DaCrm/Step2.vue'),
        component: () => import('.//components/articoli/ArticoliDaDSWeb.vue'),
        meta: {
            breadcrumb: [{ parent: 'Articoli', label: 'Dettaglio Articolo' }],
        },
    },


    {
        path: '/incassibanconista',
        name: 'incassibanconista',
        exact: true,
        component: () => import('.//components/moduloincassi/banco/IndexIncassiBanconista.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Wizard Incassi Globale' }],
        },
    },
    {
        path: '/manutenzioneincassi',
        name: 'manutenzioneincassi',
        exact: true,
        component: () => import('.//components/moduloincassi/ManutenzioneIncassi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Manutenzione Incassi' }],
        },
    },
    {
        path: '/manutenzioneacconti',
        name: 'manutenzioneacconti',
        exact: true,
        component: () => import('.//components/moduloincassi/ManutenzioneAcconti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Manutenzione Acconti' }],
        },
    },
    {
        path: '/newincassi',
        name: 'newincassi',
        exact: true,
        component: () => import('.//components/moduloincassi/IndexIncassi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Nuovi Incassi' }],
        },
    },
    {
        path: '/portafoglioagenti',
        name: 'portafoglioagenti',
        exact: true,
        component: () => import('.//components/moduloincassi/portafoglioagenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Portafoglio Agenti' }],
        },
    },

    {
        path: '/portafoglioagentibanco',
        name: 'portafoglioagentibanco',
        exact: true,
        component: () => import('.//components/moduloincassi/banco/portafoglioagentibanco.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Portafoglio Banconisti' }],
        },
    },
    {
        path: '/portafoglioaccontiagenti',
        name: 'portafoglioaccontiagenti',
        exact: true,
        component: () => import('.//components/moduloincassi/portafoglioaccontiagenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Incassi', label: 'Portafoglio Acconti' }],
        },
    },
    /*{
        path: '/riassortimentoscorte',
        name: 'riassortimentoscorte',
        exact: true,
        component: () => import('.//components/fornitori/RiassortimentoScorte.vue'),
        meta: {
            breadcrumb: [{ parent: 'Fornitore', label: 'Riassortimento Scorte' }],
        },
    },*/
    {
        path: '/testlogin',
        name: 'testlogin',
        exact: true,
        component: () => import('.//components/TestLogin.vue'),
        meta: {
            breadcrumb: [{ parent: 'Test', label: 'Login' }],
        },
    },
    {
        path: '/vendutoprodottiannocorrente',
        name: 'vendutoprodottiannocorrente',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/VendutoProdottiAnnoCorrente.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Venduto Anno Corrente' }],
        },
    },

    {
        path: '/statisticheacquisti',
        name: 'statisticheacquisti',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/StatisticheAcquisti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Statistiche Acquisti' }],
        },
    },
    {
        path: '/top50clientiperbrand',
        name: 'top50clientiperbrand',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/Top50ClientiPerBrand.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Top 50 Clienti Brand' }],
        },
    },

     {
         path: '/vendutoagentimensiletest',
         name: 'vendutoagentimensiletest',
         exact: true,
         component: () => import('.//components/DashboardPerUtente/VendutoAgentiMensile.vue'),
         meta: {
             breadcrumb: [{ parent: 'Statistiche Venduto', label: 'Venduto Prodotti AnnoCorrente' }],
         },
     },
    {
        path: '/vendutoagentimensileai',
        name: 'vendutoagentimensileai',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/VendutoAgentiMensileAI.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Venduto Agenti AI' }],
        },
    },

    {
        path: '/raccomandazionearticoli',
        name: 'raccomandazionearticoli',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/RaccomandazioneArticoli.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Raccomandazione Articoli' }],
        },
    },
    {
        path: '/ordiniinevasiarticolidsweb',
        name: 'ordiniinevasiarticolidsweb',
        exact: true,
        component: () => import('.//components/articoli/OrdiniInevasiArticoliDSWEB.vue'),
        meta: {
            breadcrumb: [{ parent: 'Articoli', label: 'Ordini Inevasi DSWeb' }],
        },
    },

    {
        path: '/productmaster',
        name: 'productmaster',
        exact: true,
        component: () => import('./components/articoli/ProductMaster.vue'),
        meta: {
            breadcrumb: [{ parent: 'Articoli', label: 'Product Master' }],
        },
    },
    {
        path: '/productpicklist',
        name: 'productpicklist',
        exact: true,
        component: () => import('./components/articoli/steps/ProductPickList.vue'),
        meta: {
            breadcrumb: [{ parent: 'Articoli', label: 'Product Picklist' }],
        },
    },

    {
        path: '/configuratorestep',
        name: 'configuratorestep',
        exact: true,
        component: () => import('./components/articoli/steps/ConfiguratoreStep.vue'),
        meta: {
            breadcrumb: [{ parent: 'Utility', label: 'Configuratore Step' }],
        },
    },

    {
        path: '/sostituzionearticoli',
        name: 'sostituzionearticoli',
        exact: true,
        component: () => import('./components/articoli/steps/SostituzioneMassivaArticoli.vue'),
        meta: {
            breadcrumb: [{ parent: 'Articoli', label: 'Sostituzione Articoli' }],
        },
    },
    {
        path: '/ordiniinevasiclienti',
        name: 'ordiniinevasiclienti',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/OrdiniInevasiClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Ordini Inevasi Clienti' }],
        },
    },
    {
        path: '/statoordiniinevasiclienti',
        name: 'statoordiniinevasiclienti',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/StatoOrdiniInevasi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Stato Ordini Inevasi' }],
        },
    },
    {
        path: '/storicovendutofatturatoagenti',
        name: 'storicovendutofatturatoagenti',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/StoricoVendutoFatturatoAgenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Storico Fatturati' }],
        },
    },

    {
        path: '/ordininonevasifiliali',
        name: 'ordininonevasifiliali',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/OrdiniNonevasiClientiPerDoc.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Ordini Non Evasi Filiali' }],
        },
    },

    {
        path: '/ordiniinevasimodugno',
        name: 'ordiniinevasimodugno',
        exact: true,
        component: () => import('.//components/magazzini/ordiniinevasi/ordiniinevasimodugno.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Ordini Inevasi Modugno' }],
        },
    },
    {
        path: '/ordiniinevasilecce',
        name: 'ordiniinevasilecce',
        exact: true,
        component: () => import('.//components/magazzini/ordiniinevasi/ordiniinevasilecce.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Ordini Inevasi Lecce' }],
        },
    },
    {
        path: '/ordiniinevasioria',
        name: 'ordiniinevasioria',
        exact: true,
        component: () => import('.//components/magazzini/ordiniinevasi/ordiniinevasioria.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Ordini Inevasi Oria' }],
        },
    },
    {
        path: '/ordiniinevasicasarano',
        name: 'ordiniinevasicasarano',
        exact: true,
        component: () => import('.//components/magazzini/ordiniinevasi/ordiniinevasicasarano.vue'),
        meta: {
            breadcrumb: [{ parent: 'Magazzini', label: 'Ordini Inevasi Casarano' }],
        },
    },
    /*{
        path: '/ordiniinevasifiliali',
        name: 'ordiniinevasifiliali',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/OrdiniInevasiClientiPerDoc.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche Venduto', label: 'Ordini Inevasi Clienti' }],
        },
    },*/


    /* {
         path: '/vendutoconincidenza',
         name: 'vendutoconincidenza',
         exact: true,
         component: () => import('.//components/Statistiche Venduto/VendutoConIncidenza.vue'),
         meta: {
             breadcrumb: [{ parent: 'Statistiche Venduto', label: 'Venduto Prodotti AnnoCorrente' }],
         },
     },*/

    {
        path: '/fatturatoperclienti',
        name: 'fatturatoperclienti',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/FatturatoPerClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Fatturato per Clienti' }],
        },
    },

    {
        path: '/fatturatoperclientifotovoltaico',
        name: 'fatturatoperclientifotovoltaico',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/FatturatoPerClientiFotovoltaico.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Fatturato Fotovoltaico' }],
        },
    },
    /*{
        path: '/confrontoagentebrand',
        name: 'confrontoagentebrand',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/ConfrontoAgenteBrand.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche Venduto', label: 'Venduto Prodotti AnnoCorrente' }],
        },
    },*/
    {
        path: '/clienti',
        name: 'clienti',
        exact: true,
        component: () => import('.//components/anagrafiche/Clienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Anagrafiche', label: 'Clienti' }],
        },
    },
   /* {
        path: '/inseriscianagraficheclienti',
        name: 'inseriscianagraficheclienti',
        exact: true,
        component: () => import('.//components/anagrafiche/InserimentoAnagraficheClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche Venduto', label: 'Venduto Prodotti AnnoCorrente' }],
        },
    },*/
    {
        path: '/fornitori',
        name: 'fornitori',
        exact: true,
        component: () => import('.//components/anagrafiche/Fornitori.vue'),
        meta: {
            breadcrumb: [{ parent: 'Anagrafiche', label: 'Fornitori' }],
        },
    },
    {
        path: '/anagrafiche',
        name: 'anagrafiche',
        exact: true,
        component: () => import('.//components/anagrafiche/Anagrafiche.vue'),
        meta: {
            breadcrumb: [{ parent: 'Anagrafiche', label: 'Anagrafiche Clienti' }],
        },
    },
    {
        path: '/articolids',
        name: 'articolids',
        exact: true,
        component: () => import('.//components/articoli/Articoli.vue'),
        meta: {
            breadcrumb: [{ parent: 'Articoli', label: 'Gestione Articoli' }],
        },
    },
    {
        path: '/richiestediarticolidadsweb',
        name: 'richiestediarticolidadsweb',
        exact: true,
        component: () => import('.//components/articoli/RichiesteDiArticoliDaDsWeb.vue'),
        meta: {
            breadcrumb: [{ parent: 'Articoli', label: 'Richieste DSWeb' }],
        },
    },
    /*{
        path: '/confrontoagentefotovoltaico',
        name: 'confrontoagentefotovoltaico',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/ConfrontoAgenteFotovoltaico.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche Venduto', label: 'Venduto Prodotti AnnoCorrente' }],
        },
    },
*/
    {
        path: '/fatturatomensile',
        name: 'fatturatomensile',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/FatturatoAgentiMensile.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Fatturato Mensile' }],
        },
    },
    {
        path: '/fatturatomensilemesiscorsi',
        name: 'fatturatomensilemesiscorsi',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/StoricoFatturatoAgenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Storico Fatturato Mensile' }],
        },
    },
    {
        path: '/fatturatopivot',
        name: 'fatturatopivot',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/FatturatoPivot.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Fatturato Pivot' }],
        },
    },
    {
        path: '/fatturatomensilefotovoltaico',
        name: 'fatturatomensilefotovoltaico',
        exact: true,
        component: () => import('.//components/Statistiche Venduto/FatturatoAgentiMensileFotovoltaico.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Fatturato Mensile Fotovoltaico' }],
        },
    },
    /*COMPONENT MANUTENZIONI*/
    {
        path: '/gestionepermessi',
        name: 'gestionepermessi',
        exact: true,
        component: () => import('.//components/GestionePermessi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Gestione', label: 'Gestione Permessi' }],
        },
    },
 {
        path: '/gestioneutenti',
        name: 'gestioneutenti',
        exact: true,
        component: () => import('.//components/gestione-utenti/GestioneUtenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Gestione Aziendale', parentTo: '/categoria/gestione-aziendale', label: 'Gestione Utenti' }],
        },
    },
    /*COMPONENT CLIENTI*/
    /*{
        path: '/inevasoclienti',
        name: 'inevasoclienti',
        exact: true,
        component: () => import('./components/clienti/.OrdiniInevasiCliente.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
        },
    },*/
    {
        path: '/presaincaricoriparazione',
        name: 'presaincaricoriparazione',
        exact: true,
        component: () => import('.//components/riparazioni/presaincarico.vue'),
        meta: {
            breadcrumb: [{ parent: 'Riparazioni', label: 'Presa in Carico' }],
        },
    },
    {
        path: '/assegnazionefornitoremarche',
        name: 'assegnazionefornitoremarche',
        exact: true,
        component: () => import('.//components/riparazioni/assegnazionefornitoremarche.vue'),
        meta: {
            breadcrumb: [{ parent: 'Riparazioni', label: 'Assegnazione Fornitore' }],
        },
    },

    {
        path: '/riparazioni',
        name: 'riparazioni',
        exact: true,
        component: () => import('.//components/riparazioni/riparazioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Riparazioni', label: 'Storico Riparazioni' }],
        },
    },
    /*  {
          path: '/statisticheriparazioni',
          name: 'statisticheriparazioni',
          exact: true,
          component: () => import('.//components/riparazioni/StatisticheRiparazioni.vue'),
          meta: {
              breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
          },
      },*/
    {
        path: '/flowriparazioni',
        name: 'flowriparazioni',
        exact: true,
        component: () => import('.//components/riparazioni/flowriparazioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Riparazioni', label: 'Flow Riparazioni' }],
        },
    },

    {
        path: '/situazionefornitori',
        name: 'situazionefornitori',
        exact: true,
        component: () => import('.//components/riparazioni/situazionefornitori.vue'),
        meta: {
            breadcrumb: [{ parent: 'Riparazioni', label: 'Situazione Fornitori' }],
        },
    },
    {
        path: '/tabledemo',
        name: 'tabledemo',
        exact: true,
        component: () => import('.//components/TableDemo.vue'),
        meta: {
            breadcrumb: [{ parent: 'Demo', label: 'Table Demo' }],
        },
    },

    /*{
        path: '/budgetcategorie',
        name: 'budgetcategorie',
        exact: true,
        component: () => import('.//components/budget/budgetcategorie.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'budgetcategorie' }],
        },
    },
    {
        path: '/entrate',
        name: 'entrate',
        exact: true,
        component: () => import('.//components/budget/entrate.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
        },
    },

    {
        path: '/uscite',
        name: 'uscite',
        exact: true,
        component: () => import('.//components/budget/uscite.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
        },
    },*/
    {
        path: '/documentaleriparazioni',
        name: 'documentaleriparazioni',
        exact: true,
        component: () => import('.//components/documentale/altro/documentaleriparazioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Documentale', label: 'Riparazioni' }],
        },
    },
    {
        path: '/storicovendutoprodotti',
        name: 'storicovendutoprodotti',
        exact: true,
        component: () => import('.//components/anagrafiche/SchedaVendutoProdotti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Statistiche', label: 'Storico Venduto Prodotti' }],
        },
    },

    {
        path: '/sacchettoclienti',
        name: 'sacchettoclienti',
        exact: true,
        component: () => import('.//components/anagrafiche/SacchettoClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Sacchetto Clienti' }],
        },
    },
    {
        path: '/sacchettoallclienti',
        name: 'sacchettoallclienti',
        exact: true,
        component: () => import('.//components/anagrafiche/SacchettoAllClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Sacchetto All Clienti' }],
        },
    },
    /* {
         path: '/statisticheacquistivendite',
         name: 'statisticheacquistivendite',
         exact: true,
         component: () => import('./components/modulostatistiche/StatisticheAcquistiVendite.vue'),
         meta: {
             breadcrumb: [{ parent: 'Clienti', label: 'Sospesi Clienti' }],
         },
     },*/
    /*  {
          path: '/anticipofatture',
          name: 'anticipofatture',
          exact: true,
          component: () => import('./components/utility/.anticipifatture/AnticipoFatture.vue'),
          meta: {
              breadcrumb: [{ parent: 'Clienti', label: 'Sospesi Clienti' }],
          },
      },*/

    {
        path: '/statorobottino',
        name: 'statorobottino',
        exact: true,
        component: () => import('.//components/utility/StatoRobottino.vue'),
        meta: {
            breadcrumb: [{ parent: 'Utility', label: 'Stato Robottino' }],
        },
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        exact: true,
        component: () => import('.//components/utility/Maintenance.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Sospesi Clienti' }],
        },
    },
    {
        path: '/temperaturasalaserver',
        name: 'temperaturasalaserver',
        exact: true,
        component: () => import('.//components/utility/TemperaturaSalaServer.vue'),
        meta: {
            breadcrumb: [{ parent: 'Utility', label: 'Temperatura Sala Server' }],
        },
    },
    /*{
        path: '/sospesiclientidaricontattare',
        name: 'sospesiclientidariconttare',
        exact: true,
        component: () => import('.//components/clienti/SospesiClientiDaRicontattare.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Sospesi Clienti' }],
        },
    },*/
    {
        path: '/statoassicurazioneclienti',
        name: 'statoassicurazioneclienti',
        exact: true,
        component: () => import('.//components/clienti/StatoAssicurazioneClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Amministrazione', label: 'Stato Assicurazione' }],
        },
    },
    /* {
         path: '/vendite',
         name: 'vendite',
         exact: true,
         component: () => import('.//components/clienti/Vendite.vue'),
         meta: {
             breadcrumb: [{ parent: 'Clienti', label: 'Vendite' }],
         },
     },*/
    /*{
        path: '/vendutodelgiorno',
        name: 'vendutodelgiorno',
        exact: true,
        component: () => import('.//components/clienti/VendutoDelGiorno.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Vendite' }],
        },
    },*/
    /*{
        path: '/vendutodelmese',
        name: 'vendutodelmese',
        exact: true,
        component: () => import('./components/clienti/.VendutoDelMese.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Vendite' }],
        },
    },*/
    /*COMPONENT BANCHE*/
    {
        path: '/flussibancari',
        name: 'flussibancari',
        exact: true,
        component: () => import('.//components/amministrazione/banche/flussibancari.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Flussi Bancari' }],
        },
    },

    {
        path: '/termometrofinanziario',
        name: 'termometrofinanziario',
        exact: true,
        component: () => import('.//components/amministrazione/banche/TermometroFinanziario.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Termometro Finanziario' }],
        },
    },

    {
        path: '/termometrofinanziariosemplice',
        name: 'termometrofinanziariosemplice',
        exact: true,
        component: () => import('.//components/amministrazione/banche/TermometroFinanziarioSemplificato.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Termometro Semplice' }],
        },
    },
    {
        path: '/coperturacreditoassegni',
        name: 'coperturacreditoassegni',
        exact: true,
        component: () => import('.//components/amministrazione/banche/CoperturaCreditoAssegni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Copertura Credito Assegni' }],
        },
    },
    {
        path: '/anticipobancheriba',
        name: 'anticipobancheriba',
        exact: true,
        component: () => import('.//components/amministrazione/banche/AnticipiBancheRiba.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Anticipo Riba' }],
        },
    },
    {
        path: '/saldibanche',
        name: 'saldibanche',
        exact: true,
        component: () => import('.//components/amministrazione/banche/saldibanche.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Saldi Banche' }],
        },
    },

    /* {
         path: '/manutenzionebanche',
         name: 'manutenzionebanche',
         exact: true,
         component: () => import('.//components/amministrazione/banche/manutenzionebanche.vue'),
         meta: {
             breadcrumb: [{ parent: 'Banche', label: 'Banche' }],
         },
     },*/

    /*{
        path: '/finanziamenti',
        name: 'finanziamenti',
        exact: true,
        component: () => import('.//components/amministrazione/finanziamenti/Finanziamenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Banche' }],
        },
    },*/
    /*{
        path: '/statoclienti',
        name: 'statoclienti',
        exact: true,
        component: () => import('.//components/amministrazione/StatoClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Banche' }],
        },
    },*/
    {
        path: '/calcolodso',
        name: 'calcolodso',
        exact: true,
        component: () => import('.//components/amministrazione/CalcoloDso.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Calcolo DSO' }],
        },
    },
    {
        path: '/calcolocostodso',
        name: 'calcolocostodso',
        exact: true,
        component: () => import('.//components/amministrazione/CalcoloCostoDso.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Costo Ritardo Pagamento' }],
        },
    },

    {
        path: '/clientiinattivi',
        name: 'clientiinattivi',
        exact: true,
        component: () => import('.//components/anagrafiche/ClientiInattivi.vue'),
        meta: {
            breadcrumb: [{ parent: 'Anagrafiche', label: 'Clienti Inattivi' }],
        },
    },
    {
        path: '/scadenzarioajax',
        name: 'scadenzarioajax',
        exact: true,
        component: () => import('.//components/amministrazione/ScadenzarioAjax.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Scadenzario AJAX' }],
        },
    },
    {
        path: '/scadenzarioajaxap',
        name: 'scadenzarioajaxap',
        exact: true,
        component: () => import('.//components/amministrazione/ScadenzarioAjaxAP.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Scadenzario AJAX AP' }],
        },
    },
    /* {
         path: '/visitatorisbl',
         name: 'visitatorisbl',
         exact: true,
         component: () => import('./components/clienti/.VisitatoriSBL.vue'),
         meta: {
             breadcrumb: [{ parent: 'Banche', label: 'Banche' }],
         },
     },*/

    {
        path: '/calcolocostodsoideale',
        name: 'calcolocostodsoideale',
        exact: true,
        component: () => import('.//components/amministrazione/CalcoloCostoDsoIdeale.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Costo DSO Ideale' }],
        },
    },
    {
        path: '/statofidiclienti',
        name: 'statofidiclienti',
        exact: true,
        component: () => import('.//components/amministrazione/StatoFidiClienti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Stato Fidi Clienti' }],
        },
    },
    {
        path: '/budgetcashflow',
        name: 'budgetcashflow',
        exact: true,
        component: () => import('.//components/cashflow/BudgetCashFlow.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Budget Cash Flow' }],
        },
    },
    {
        path: '/costioperativi',
        name: 'costioperativi',
        exact: true,
        component: () => import('.//components/cashflow/dialogDettaglioCashFlow/dialogDettaglioCostiOperativiGlobali.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Costi Operativi' }],
        },
    },
    {
        path: '/costibanche',
        name: 'costibanche',
        exact: true,
        component: () => import('.//components/cashflow/dialogDettaglioCashFlow/dialogDettaglioCostiBanche.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Costi Banche' }],
        },
    },
    {
        path: '/gestionemarca',
        name: 'gestionemarca',
        exact: true,
        component: () => import('.//components/cashflow/GestoreMarca.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Gestione Marca' }],
        },
    },
    /*   {
           path: '/costiprevisti',
           name: 'costiprevisti',
           exact: true,
           component: () => import('.//components/cashflow/CostiPrevisti.vue'),
           meta: {
               breadcrumb: [{ parent: 'Banche', label: 'Banche' }],
           },
       },*/
    {
        path: '/scadenzeapertefornitore',
        name: 'scadenzeapertefornitore',
        exact: true,
        component: () => import('.//components/cashflow/ScadenzarioFornitori.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Scadenze Aperte Fornitore' }],
        },
    },
    {
        path: '/scadenzefinemesefornitore',
        name: 'scadenzefinemesefornitore',
        exact: true,
        component: () => import('.//components/cashflow/ScadenzeFineMese.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Scadenze Fine Mese' }],
        },
    },

    {
        path: '/ordiniaperticlientiperdocumentocashflow',
        name: 'ordiniaperticlientiperdocumentocashflow',
        exact: true,
        component: () => import('.//components/cashflow/dialogDettaglioCashFlow/dialogOrdiniInevasiClientiPerDocCashflow.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Ordini Aperti Clienti' }],
        },
    },
    {
        path: '/dialogcommenti',
        name: 'dialogcommenti',
        exact: true,
        component: () => import('./components/cashflow/dialogCommenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Commenti' }],
        },
    },
    {
        path: '/pdfscadenzeraggruppato',
        name: 'pdfscadenzeraggruppato',
        exact: true,
        component: () => import('.//components/cashflow/PDFScadenzeRaggruppato.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'PDF Scadenze' }],
        },
    },
    {
        path: '/budgetcashflow2',
        name: 'budgetcashflow2',
        exact: true,
        component: () => import('./components/cashflow/BudgetCashFlowV2.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Budget Cash Flow V2' }],
        },
    },
    {
        path: '/centrodicosto',
        name: 'centrodicosco',
        exact: true,
        component: () => import('.//components/cashflow/CentroDiCosto.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Centro Di Costo' }],
        },
    },

    {
        path: '/calcoloiva',
        name: 'calcoloiva',
        exact: true,
        component: () => import('.//components/cashflow/CalcoloIva.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Calcolo IVA' }],
        },
    },
    {
        path: '/dialogdettagliocashflowuscite',
        name: 'dialogdettagliocashflowuscite',
        exact: true,
        component: () => import('./components/cashflow/dialogDettaglioCashFlowUscite.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Dettaglio Uscite' }],
        },
    },


    {
        path: '/scadenzario',
        name: 'scadenzario',
        exact: true,
        component: () => import('.//components/cashflow//scadenzario/Scadenzario.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Scadenzario' }],
        },
    },
    {
        path: '/statoordinifornitoriconsegne',
        name: 'statoordinifornitoriconsegne',
        exact: true,
        component: () => import('.//components/cashflow/StatoOrdini.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Stato Ordini Fornitori' }],
        },
    },
    {
        path: '/ordiniinevasipermarca',
        name: 'ordiniinevasipermarca',
        exact: true,
        component: () => import('.//components/cashflow/OrdiniInevasiPerMarca.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Ordini Inevasi Per Marca' }],
        },
    },
    {
        path: '/caricacontratti',
        name: 'caricacontratti',
        exact: true,
        component: () => import('.//components/anagrafiche/CaricaContratti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Cash Flow', label: 'Carica Contratti' }],
        },
    },
    /*{
        path: '/manutenzionefinanziamenti',
        name: 'manutenzionefinanziamenti',
        exact: true,
        component: () => import('.//components/amministrazione/finanziamenti/ManutenzioneFinanziamenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Banche', label: 'Banche' }],
        },
    },
*/
    /*COMPONENT PROMOZIONI*/
    {
        path: '/andamentopromozioni',
        name: 'andamentopromozioni',
        exact: true,
        component: () => import('.//components/promozioni/AndamentoPromozioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Commerciale', label: 'Andamento Promozioni' }],
        },
    },
    /*  {
          path: '/listiniribassati',
          name: 'listiniribassati',
          exact: true,
          component: () => import('.//components/promozioni/ListiniRibassati.vue'),
          meta: {
              breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
          },
      },*/
    /* {
         path: '/anagraficheclientis',
         name: 'anagraficheclientis',
         exact: true,
         component: () => import('.//components/clienti/AnagraficheClienti.vue'),
         meta: {
             breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
             requiresAuth: true
         },
     },
     {
         path: '/budgetagentimese',
         name: 'budgetagentimese',
         exact: true,
         component: () => import('./components/.agenti/BudgetAgentiMese.vue'),
         meta: {
             breadcrumb: [{ parent: 'Agenti', label: 'Budget Agenti' }],
             requiresAuth: true
         },
     },
     */

    {
        path: '/venditepop',
        name: 'venditepop',
        exact: true,
        component: () => import('./components/agenti/ModuloCalcolo/CalcoloPop.vue'),
        meta: {
            breadcrumb: [{ parent: 'Agenti', label: 'Vendite POP' }],
            requiresAuth: true
        },
    },
    {
        path: '/gestione-provvigioni',
        name: 'gestione-provvigioni',
        exact: true,
        component: () => import('./components/agenti/ModuloProvvigioni/ProvvigioniForm.vue'),
        meta: {
            breadcrumb: [{ parent: 'Agenti', label: 'Gestione Provvigioni' }],
            requiresAuth: true
        },
    },

    {
        path: '/monitoraggioprovvigioni',
        name: 'monitoraggioprovvigioni',
        exact: true,
        component: () => import('./components/agenti/ModuloProvvigioni/MonitoraggioProvvigioni.vue'),
        meta: {
            breadcrumb: [{ parent: 'Agenti', label: 'Monitoraggio Provvigioni' }],
            requiresAuth: true
        },
    },
    {
        path: '/marchetable',
        name: 'marchetable',
        exact: true,
        component: () => import('./components/agenti/ModuloProvvigioni/MarcheTable.vue'),
        meta: {
            breadcrumb: [{ parent: 'Agenti', label: 'Marche Table' }],
            requiresAuth: true
        },
    },

    {
        path: '/associazioniform',
        name: 'associazioniform',
        exact: true,
        component: () => import('./components/agenti/ModuloProvvigioni/AssociazioniForm.vue'),
        meta: {
            breadcrumb: [{ parent: 'Agenti', label: 'Associazioni Form' }],
            requiresAuth: true
        },
    },


    /*{
        path: '/costi',
        name: 'costi',
        exact: true,
        component: () => import('.//components/costi/index.vue'),
    },
    {
        path: '/manutenzioneCosti',
        name: 'manutenzioneCosti',
        exact: true,
        component: () => import('.//components/costi/componentes/crudTable.vue'),
        meta: {
            breadcrumb: [{ parent: 'Costi', label: 'Manutenzione Costi' }],
        },
    },
    {
        path: '/costimartina',
        name: 'costimartina',
        exact: true,
        component: () => import('.//components/costi/sedes/martina.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
            requiresAuth: true
        },
    },
    {
        path: '/costimodugno',
        name: 'costimodugno',
        exact: true,
        component: () => import('.//components/costi/sedes/modugno.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
            requiresAuth: true
        },
    },
    {
        path: '/costilecce',
        name: 'costilecce',
        exact: true,
        component: () => import('.//components/costi/sedes/lecce.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
            requiresAuth: true
        },
    },
    {
        path: '/costioria',
        name: 'costioria',
        exact: true,
        component: () => import('.//components/costi/sedes/oria.vue'),
        meta: {
            breadcrumb: [{ parent: 'Clienti', label: 'Ordini Inevasi Cliente' }],
            requiresAuth: true
        },
    },*/
    {
        path: '/update-chat-status',
        name: 'update-chat-status',
        exact: true,
        component: () => import('.//pages/UpdateChatStatus.vue'),
        meta: {
            breadcrumb: [{ parent: 'Teams', label: 'Cambio Status Chat' }],
            requiresAuth: true
        },
    },
    /*{
        path: '/masterfinanziamenti',
        name: 'masterfinanziamenti',
        exact: true,
        component: () => import('.//components/finanziamenti/MasterFinanziamenti.vue'),
        meta: {
            breadcrumb: [{ parent: 'Finanziamenti', label: 'Master Finanziamenti' }],
            requiresAuth: true
        },
    },*/

    /*{
        path: '/testandrea',
        name: 'testandrea',
        exact: true,
        component: () => import('.//components/andrea/testcard.vue'),
        meta: {
            breadcrumb: [{ parent: 'test', label: 'andrea' }],
        },
    },*/
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    }
});

async function getMaintenanceStatus() {
    try {
        const response = await axios.get('/maintenance', { timeout: 3000 });
        console.log('Maintenance status:', response.data);
        return response.data;
    } catch (error) {
        console.warn('Impossibile verificare lo stato di manutenzione:', error.message);
        return { active: false };
    }
}

router.beforeEach(async (to, from, next) => {
    const maintenance = await getMaintenanceStatus();
    if (maintenance.active && to.name !== 'maintenance') {
        next('/maintenance');
        return;
    }
    console.log('to', to);
    console.log('from', from);
    if (to.name == "login") {
        if (localStorage.getItem('token')) {
            next(from.path);
        } else {
            next();
        }
    } else {
        console.log('pagina diversa da login')
        const token = localStorage.getItem('token');
        if (token) {
            let decodedToken;
            try {
                decodedToken = VueJwtDecode.decode(token);
            } catch (error) {
                console.log('token scaduto');
                next('/login');
                return;
            }
            console.log('decodedToken', decodedToken);
            console.log('to', to);
            const role = decodedToken.ruolo;
            const username = decodedToken.nickname;
            const currentPath = to.matched[0].path;
            
            // Rotte pubbliche accessibili a tutti gli utenti autenticati
            if (isPublicRoute(currentPath)) {
                next();
                return;
            }
            
            // Controlla se esiste una configurazione specifica per utente
            const userPermissions = routeUserPermissionsMap[currentPath];
            if (userPermissions) {
                // Sistema permessi specifici per utente
                const hasRoleAccess = userPermissions.roles.some(r => r === role);
                const isSpecificUser = userPermissions.specificUsers.includes(username);
                
                if (hasRoleAccess || isSpecificUser) {
                    next();
                } else {
                    // Salva messaggio di errore per mostrare toast nella pagina unauthorized
                    sessionStorage.setItem('accessDeniedMessage', `Accesso negato alla rotta: ${to.path}`);
                    sessionStorage.setItem('accessDeniedReason', `Il tuo ruolo (${role}) non ha i permessi necessari`);
                    next('/unauthorized');
                }
                return;
            }
            
            // Sistema permessi tradizionale (solo ruoli)
            const routePermissions = routePermissionsMap[currentPath];
            if (!routePermissions) {
                // Se la rotta non ha permessi definiti, NEGA l'accesso per sicurezza
                console.warn(`⚠️ ACCESSO NEGATO: La rotta "${currentPath}" non ha permessi definiti in routePermissionsMap`);
                sessionStorage.setItem('accessDeniedMessage', `Rotta non configurata: ${to.path}`);
                sessionStorage.setItem('accessDeniedReason', 'Questa funzionalità non ha ancora i permessi configurati. Contatta l\'amministratore.');
                next('/unauthorized');
                return;
            }
            
            if (routePermissions.some(r => r == role)) {
                next();
            } else {
                // Salva messaggio di errore per mostrare toast nella pagina unauthorized
                sessionStorage.setItem('accessDeniedMessage', `Accesso negato alla rotta: ${to.path}`);
                sessionStorage.setItem('accessDeniedReason', `Il tuo ruolo (${role}) non ha accesso. Ruoli richiesti: ${routePermissions.join(', ')}`);
                next('/unauthorized');
            }
        } else {
            console.log('non hai il token');
            next('/login');
        }
    }

})

export default router;